'use client';

import { GirlLocation } from '@/components/girl/girl-location';
import { GirlPrices } from '@/components/girl/girl-prices';
import dynamic from 'next/dynamic';
const RequestModal = dynamic(() => import('./request-modal'));

import { GirlAbout } from '@/components/girl/girl-about';
import { GirlGos } from '@/components/girl/girl-gos';
import { GirlInterview } from '@/components/girl/girl-interview';
import { GirLSlideshow } from '@/components/girl/girl-slideshow';
import LikeProvider from '@/components/likes/like.provider';
import {
  attendantAboutTitle,
  attendantFeeTitle,
  attendantGalleryTitle,
  attendantInterviewTitle,
  attendantPreferencesTitle,
  attendantTravelCostsTitle,
} from '@bells/i18n';
import { AttendantSearchSingleResponse } from '@bells/schema/models/attendant';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@bells/ui/components/tabs';
import { useState } from 'react';
import { GirlDesktopHeader } from './girl-desktop-header';
import { usePathname } from 'next/navigation';
import { cn } from '@bells/core/lib/utils';
import { usePwaRouter } from '@bells/ui/utils/use-pwa';

export const GirlLayout = ({
  data,
}: {
  data?: AttendantSearchSingleResponse;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const isPwa = usePwaRouter();
  return (
    <LikeProvider
      likes={data?.totalLikes}
      entity={'AttendantEntity'}
      entityId={data?.id}
    >
      <div
        style={{
          paddingBottom: isPwa
            ? 'calc(50px + env(safe-area-inset-bottom, 0px))'
            : '',
          paddingTop: isPwa ? '50px' : '',
        }}
        className={cn(
          'mx-auto flex w-full max-w-screen-xl flex-col p-0 lg:my-8 lg:px-8'
        )}
      >
        {data && (
          <RequestModal
            data={data}
            open={open}
            setOpen={setOpen}
          ></RequestModal>
        )}

        <div className='grid w-full grid-cols-1 gap-4 lg:grid-cols-[30%_1fr] lg:gap-8'>
          <GirlDesktopHeader setOpen={setOpen} data={data}></GirlDesktopHeader>

          <div className='mx-auto w-full max-w-[950px]'>
            <Tabs defaultValue={'images'} className='w-full rounded-none'>
              <div className='scrollbar-hide mb-4 w-full overflow-hidden overflow-x-auto lg:mb-6'>
                <TabsList className='inline-flex h-auto w-full justify-start rounded-none border-b border-input bg-transparent pb-1 shadow-none lg:w-auto'>
                  <TabsTrigger
                    className='-mb-1 rounded-none border-b-2 border-transparent py-2.5 text-sm font-medium data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none'
                    value={'images'}
                  >
                    <span>{attendantGalleryTitle()}</span>
                  </TabsTrigger>
                  <TabsTrigger
                    className='-mb-1 rounded-none border-b-2 border-transparent py-2.5 text-sm font-medium data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none'
                    value={`about`}
                  >
                    {attendantAboutTitle()}
                  </TabsTrigger>
                  <TabsTrigger
                    className='-mb-1 rounded-none border-b-2 border-transparent py-2.5 text-sm font-medium data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none'
                    value={`gos`}
                  >
                    {attendantPreferencesTitle()}
                  </TabsTrigger>
                  <TabsTrigger
                    className='-mb-1 rounded-none border-b-2 border-transparent py-2.5 text-sm font-medium data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none'
                    value={`prices`}
                  >
                    {attendantFeeTitle()}
                  </TabsTrigger>

                  <TabsTrigger
                    className='-mb-1 rounded-none border-b-2 border-transparent py-2.5 text-sm font-medium data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none'
                    value={`location`}
                  >
                    {attendantTravelCostsTitle()}
                  </TabsTrigger>

                  <TabsTrigger
                    className='-mb-1 rounded-none border-b-2 border-transparent py-2.5 text-sm font-medium data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none'
                    value={`interview`}
                  >
                    {attendantInterviewTitle()}
                  </TabsTrigger>
                </TabsList>
              </div>

              <TabsContent value='images'>
                <div className='w-full px-0 lg:p-0'>
                  <GirLSlideshow data={data}></GirLSlideshow>
                </div>
              </TabsContent>
              <TabsContent value='location'>
                <div className='w-full px-4 lg:p-0'>
                  <GirlLocation data={data}></GirlLocation>
                </div>
              </TabsContent>
              <TabsContent value='about'>
                <div className='w-full px-4 lg:p-0'>
                  <GirlAbout data={data}></GirlAbout>
                </div>
              </TabsContent>
              <TabsContent value='prices'>
                <div className='w-full px-4 lg:p-0'>
                  <GirlPrices data={data}></GirlPrices>
                </div>
              </TabsContent>
              <TabsContent value='gos'>
                <div className='w-full px-4 lg:p-0'>
                  <GirlGos data={data}></GirlGos>
                </div>
              </TabsContent>
              <TabsContent value='interview'>
                <div className='w-full px-4 lg:p-0'>
                  <GirlInterview data={data}></GirlInterview>
                </div>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
          .scrollbar-hide {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}
      </style>
    </LikeProvider>
  );
};
